"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameInfoFromExtension = exports.HOI4 = exports.EU4 = exports.CK2 = exports.CompressMode = void 0;
/**
 * barrel
 */
var CK2_1 = require("./CK2");
exports.CK2 = CK2_1.default;
var EU4_1 = require("./EU4");
exports.EU4 = EU4_1.default;
var GameInfo_1 = require("./GameInfo");
Object.defineProperty(exports, "CompressMode", { enumerable: true, get: function () { return GameInfo_1.CompressMode; } });
var HOI4_1 = require("./HOI4");
exports.HOI4 = HOI4_1.default;
var IR_1 = require("./IR");
/**
 * Gives you the appropriate GameInfo object for the provided extension.
 * @param ext File extension including period (like .eu4)
 */
function getGameInfoFromExtension(ext) {
    switch (ext) {
        case CK2_1.default.Extension:
            return CK2_1.default;
        case EU4_1.default.Extension:
            return EU4_1.default;
        case HOI4_1.default.Extension:
            return HOI4_1.default;
        case IR_1.default.Extension:
            return IR_1.default;
        default:
            throw new Error("could not guess game from extension '" + ext + "'");
    }
}
exports.getGameInfoFromExtension = getGameInfoFromExtension;
